import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { Errors } from 'src/infrastructure/labels/errors';
import { Successes } from 'src/infrastructure/labels/successes';
import { Validator } from 'src/infrastructure/validation/validator';
import { ImageCollection } from 'src/models/DTO/image/imageCollection';
import { UserDTO } from 'src/models/DTO/user/user';
import { DeleteImage } from 'src/models/requestModels/images/DeleteImage';
import { CreateNewBase64Image } from 'src/models/requestModels/images/Image';
import { UserService } from 'src/services/core/user/user.service';
import { ContactService } from 'src/services/request/contact/contact.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { UserInfoService } from 'src/services/request/user/userinfo.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent extends HistoryBaseComponent implements OnInit {

  private _loggedUser: UserDTO | null = null;
  private _image?: ImageCollection
  changeAccountInfo?: FormGroup;

  
  constructor(
    private userService: UserService,
    private userStateService: LoggedUserService,
    private imagesService: ImagesService,
    private userInfoService: UserInfoService,
    private router: Router,
    private toastr: ToastrService,
    protected location: Location,
    private FB: FormBuilder,
    private modalService: NgbModal,
    protected historyService: HistoryService
  ) { 
    super(location, historyService);
    this.pageTitle = 'accountinfo';
    this.userStateService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
      if (user && Object.keys(user).length) {
        this.imagesService.getImagesPerProduct("USER", this._loggedUser?.data.uuid || '', 'logo').subscribe(images => {
          this._image = images;
        })
        this.changeAccountInfo = FB.group({
          firstName: [this.loggedUser?.data?.fist_name, [Validators.required]],
          lastName: [this.loggedUser?.data?.last_name, [Validators.required]],
          phone: [this.phone, [Validators.required]]
        });
      }
    })
   }

  ngOnInit(): void {
  }

  get isUserLogged() {
    return this.userService.isUserLogged();
  }

  get loggedUser() {
    return this._loggedUser;
  }

  get image() {
    return this._image?.data[0]?.original.url || '/assets/images/account/account-image-not-found.svg';
  }
  
  get phone() {
    if (!this.loggedUser?.data.telephone_info || this.loggedUser?.data.telephone_info == Config.emptyInputPlaceholder) {
      return ''
    }
    return this.loggedUser?.data.telephone_info;
  }

  avatarUpload(event: any) {
    const file = event.target.files[0];
    let self = this;
    if (!Validator.Images.allowedImages.validate(file.name.split('.').pop())) {
      this.toastr.error(Errors.bg.imageType)
      throw new Error(Errors.bg.imageType);
    }
    if (!Validator.Images.maxSizeOfImage.validate(file.size)) {
      this.toastr.error(Errors.bg.imageMaxSize)
      throw new Error(Errors.bg.imageMaxSize);
    }
    
    let fr = new FileReader();
    fr.addEventListener("load", function () {
      const content = fr.result?.toString().substring(fr.result.toString().indexOf(',') + 1) || '';
      const imageToDelete : DeleteImage = {
        subject_type: 'USER',
        subject_uuid: self.loggedUser?.data.uuid || '',
        uuid: self._image?.data[0]?.uuid || ''
      };
      if (self._image?.data[0]?.uuid) {
        self.imagesService.deleteImage(imageToDelete).toPromise().then(() => {
          self.createAvatar(content);
        })
      }
      else {
        self.createAvatar(content);
      }
    }, false);

    fr.readAsDataURL(file);

  }

  private createAvatar(content: string) {
    const createImage : CreateNewBase64Image = {
      subject_type: 'USER',
      subject_uuid: this.loggedUser?.data.uuid || '',
      collection: 'logo',
      uploads: [
        {
          base64: content
        }
      ]
    }
    this.imagesService.createNewImage(createImage).subscribe(() => {
      this.imagesService.getImagesPerProduct("USER", this._loggedUser?.data.uuid || '', 'logo').subscribe(images => {
        this._image = images;
      })
    })
  }

  private reloadUser() {
    this.userInfoService.loadUser().subscribe(user => {
      this.userStateService.addNewUser(user);
      this.toastr.success(Successes.bg.updateUser);
    })
  }

  onChangeAccount() {
    this.userInfoService.updateUser({
      first_name: this.changeAccountInfo?.get('firstName')?.value,
      last_name: this.changeAccountInfo?.get('lastName')?.value
    }).subscribe(() => {
      if (this.changeAccountInfo?.get('phone')?.value) {
        this.userInfoService.updateTelephone(
          this.changeAccountInfo?.get('phone')?.value
        ).subscribe(() => this.reloadUser());
      }
      else {
        this.reloadUser()
      }

    })
  }

  onDeleteAccountTap(modal: any) {
    this.userInfoService.deleteUser().subscribe(() => {
      modal.close();
      this.toastr.success(Successes.bg.deletedUser);
      this.router.navigate(['login'])
    })
  }

  onDeleteAccountButton(modal: any) {
    this.modalService.open(modal, { centered: true, size: 'sm' })
  }

}
